<div class="phase-step-container">
  <dx-scroll-view>
    <dx-sortable
      class="display-node-children-list"
      [data]="phases"
      handle=".drag-handle"
      (onReorder)="onPhaseReorder($event)"
    >
      @for (phase of phases; track $index) {
        <app-setup-phase-node
          [phase]="phase"
          [phases]="phases"
          [editing]="true"
          [validationGroup]="validationGroup"
          [allowDelete]="phases.length >= 1"
          (onDelete)="onPhaseDeleted($index)"
          (onValidationChange)="onPhaseValidationChange()"
        ></app-setup-phase-node>
      }
    </dx-sortable>
    <div class="create-button-container">
      <app-gpd-button
        i18n-text="@@addMorePhases"
        text="Add More Phases"
        icon="add"
        type="secondary"
        (onClick)="addNewPhase()"
      ></app-gpd-button>
    </div>
  </dx-scroll-view>

  <dx-validator [adapter]="phaseAdapterConfig">
    <dxi-validation-rule
      type="custom"
      [validationCallback]="phaseValidationCallback"
      i18n-message="@@phaseConfigInvalidValidationMessage"
      message="Phase configuration is invalid"
      style="display: none"
    ></dxi-validation-rule>
  </dx-validator>
</div>
